import type { ProvinceCentroids } from './types'

/**
 * Centroide aproximado (capital de provincia) de cada slug de `PROVINCES`,
 * excepto `'todos'` (no es un resultado de detección válido — research.md §3).
 * Usado únicamente por `resolveProvinceFromCoordinates` para nearest-neighbor;
 * no se promueve a `src/app/lib/constants.ts` por ser exclusivo de esta
 * resolución (Constitución II, colocación local-first).
 */
export const PROVINCE_CENTROIDS: ProvinceCentroids = {
  alava: { lat: 42.8467, lng: -2.6716 },
  albacete: { lat: 38.9943, lng: -1.8585 },
  alicante: { lat: 38.3452, lng: -0.481 },
  almeria: { lat: 36.8381, lng: -2.4597 },
  asturias: { lat: 43.3603, lng: -5.8448 },
  avila: { lat: 40.6566, lng: -4.6818 },
  badajoz: { lat: 38.8794, lng: -6.9707 },
  baleares: { lat: 39.5696, lng: 2.6502 },
  barcelona: { lat: 41.3851, lng: 2.1734 },
  burgos: { lat: 42.3439, lng: -3.6969 },
  caceres: { lat: 39.4753, lng: -6.3724 },
  cadiz: { lat: 36.5271, lng: -6.2886 },
  cantabria: { lat: 43.4623, lng: -3.8099 },
  castellon: { lat: 39.9864, lng: -0.0513 },
  ceuta: { lat: 35.8894, lng: -5.3213 },
  'ciudad-real': { lat: 38.9848, lng: -3.9274 },
  cordoba: { lat: 37.8882, lng: -4.7794 },
  coruna: { lat: 43.3623, lng: -8.4115 },
  cuenca: { lat: 40.0704, lng: -2.1374 },
  girona: { lat: 41.9794, lng: 2.8214 },
  granada: { lat: 37.1773, lng: -3.5986 },
  guadalajara: { lat: 40.6333, lng: -3.1669 },
  guipuzcoa: { lat: 43.3183, lng: -1.9812 },
  huelva: { lat: 37.2614, lng: -6.9447 },
  huesca: { lat: 42.1401, lng: -0.4089 },
  jaen: { lat: 37.7796, lng: -3.7849 },
  leon: { lat: 42.5987, lng: -5.5671 },
  lleida: { lat: 41.6176, lng: 0.62 },
  rioja: { lat: 42.465, lng: -2.4487 },
  lugo: { lat: 43.0097, lng: -7.5567 },
  madrid: { lat: 40.4168, lng: -3.7038 },
  malaga: { lat: 36.7213, lng: -4.4213 },
  murcia: { lat: 37.9922, lng: -1.1307 },
  navarra: { lat: 42.8125, lng: -1.6458 },
  ourense: { lat: 42.3364, lng: -7.8639 },
  palencia: { lat: 42.0096, lng: -4.5288 },
  palmas: { lat: 28.1235, lng: -15.4363 },
  pontevedra: { lat: 42.431, lng: -8.6444 },
  salamanca: { lat: 40.9701, lng: -5.6635 },
  'santa-cruz-de-tenerife': { lat: 28.4636, lng: -16.2518 },
  segovia: { lat: 40.9429, lng: -4.1088 },
  sevilla: { lat: 37.3891, lng: -5.9845 },
  soria: { lat: 41.7636, lng: -2.4649 },
  tarragona: { lat: 41.1189, lng: 1.2445 },
  teruel: { lat: 40.3456, lng: -1.1065 },
  toledo: { lat: 39.8628, lng: -4.0273 },
  valencia: { lat: 39.4699, lng: -0.3763 },
  valladolid: { lat: 41.6523, lng: -4.7245 },
  vizcaya: { lat: 43.263, lng: -2.935 },
  zamora: { lat: 41.5033, lng: -5.7446 },
  zaragoza: { lat: 41.6488, lng: -0.8891 },
  melilla: { lat: 35.2919, lng: -2.9381 },
}
